import { Flex, Link, Callout, Text } from "@wayflyer/flyui";
import { FormattedMessage, useIntl } from "react-intl";

import { MESSAGES } from "./message-definitions";

export const AuOpenBankingBanner = () => {
  const intl = useIntl();

  return (
    <Callout
      variant="info"
      title={intl.formatMessage(MESSAGES.auOpenBankingBannerTitle)}
      description={
        <Flex direction="column" gap="0">
          <Text>
            <FormattedMessage
              {...MESSAGES.auOpenBankingOptIn}
              values={{
                b: (chunks: string) => (
                  <Text element="span" fontWeight="semiBold">
                    {chunks}
                  </Text>
                ),
              }}
            />
          </Text>
          <Text>
            <FormattedMessage
              {...MESSAGES.auOpenBankingDataSharingLink}
              values={{
                a: (chunks: string) => (
                  <Link
                    url="https://help-center.wayflyer.com/en/articles/361036-how-do-i-opt-in-to-data-sharing-in-australia"
                    external
                  >
                    {chunks}
                  </Link>
                ),
              }}
            />
          </Text>
        </Flex>
      }
    />
  );
};
